// extracted by mini-css-extract-plugin
export var cancelButton = "_ok-5";
export var content = "_ok-3";
export var createButton = "_ok-6";
export var drawerContainer = "_ok-0";
export var footer = "_ok-2";
export var header = "_ok-1";
export var orderFormColumn = "_ok-4";